module.exports = __webpack_public_path__ + "img/telematik.33c571ce.svg";